var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuringPhaseRing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.66667,
    stroke: "#C9E4D5",
    strokeWidth: 2.66667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.33333C8.87548 1.33333 9.74239 1.50577 10.5512 1.8408C11.3601 2.17583 12.095 2.6669 12.714 3.28596C13.3331 3.90501 13.8242 4.63994 14.1592 5.44878C14.4942 6.25762 14.6667 7.12452 14.6667 8",
    stroke: "#609678",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuringPhaseRing);
export default __webpack_public_path__ + "static/media/during-phase-ring.10dd15cf31413a8df43f1847a686c1eb.svg";
export { ForwardRef as ReactComponent };